<template>
  <div class="resume">
    <div class="resume-editor" ref="editorFrom">
      <div>
        <!-- 求职意向 -->
        <div class="resumeSection">
          <div>
            <h2 class="resumeSection__title">个人优势</h2>
          </div>
          <div class="resumeSection__form">
            <div class="tips">{{ text }}</div>
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item prop="personalAdventage">
                <el-input
                  type="textarea"
                  :rows="12"
                  maxlength="200"
                  show-word-limit
                  v-model="form.personalAdventage"
                  placeholder="亮出自己的个人优势，更能得到HR的青睐哦~"
                  @input="handleInput"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="trigger" @click="show">看看别人怎么写</div>
            <div class="superiorityEg" v-if="flag">
              <div class="superiorityEgInner">
                <div class="superiorityTit">
                  <div class="title">{{ advantage[index].label }}</div>
                  <div class="cut" @click="changeText">换一个</div>
                </div>
                <div id="template" class="superiorityContent">
                  {{ advantage[index].text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="footerAction" class="resumeEditor-footerAction">
      <el-button round @click="$router.push('/resume')">取消</el-button>
      <el-button size="medium" @click="submit" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import { personalInfo, personalInfoCommit } from "@/api/index";
import advantage from "@/helper/data_template.js";
import { Debounce } from "@/helper/utilities.js";
export default {
  name: "resume-advantage",
  data() {
    return {
      text: "个人优势，至少5个字哦!",
      flag: false,
      index: "0",
      min: "5", //最少字数
      advantage: advantage.advantage,
      form: {
        personalAdventage: undefined
      },
      rules: {}
    };
  },
  created() {
    this.getPersonalInfo();
  },
  methods: {
    getPersonalInfo() {
      personalInfo()
        .then(res => {
          if (res.code == 200) {
            if (res.data.reMiniProgramPerson) {
              this.form = res.data.reMiniProgramPerson;
            }
          }
        })
        .catch(err => {});
    },

    //显示文本模板
    show() {
      this.flag = !this.flag;
    },

    //换文本模板
    changeText() {
      let advantage = this.advantage;
      this.index++;
      if (this.index >= advantage.length) {
        this.index = 0;
      }
    },

    handleInput(event) {
      //获取输入框内容的长度
      let len = parseInt(event.length);
      //最少字数限制
      if (len <= this.min) this.text = "加油，够5个字可以哦!";
      else if (len > this.min) this.text = "越接近150个字越容易得满分哦!";
    },

    submit: Debounce(function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          personalInfoCommit(this.form)
            .then(res => {
              if (res.code == 200) {
                this.$router.go(-1);
                this.$message({
                  showClose: true,
                  message: "保存成功",
                  type: "success"
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: "warning"
                });
              }
            })
            .catch(err => {});
        }
      });
    }, 1000)
  }
};
</script>

<style lang="less" scoped>
.resume {
  margin-bottom: 30px;
}
.resume-editor {
  width: 900px;
  margin: auto;
  padding: 30px 0;
}
.resumeEditor-footerAction {
  width: 900px;
  margin: auto;
  z-index: 33;
  text-align: right;
  &-fix {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;

    box-shadow: 0 -2px 10px #eee;
  }
}
.resumeSection {
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @border-base-color;

  &__title {
    margin-right: 200px;

    padding-bottom: 3px;
    border-bottom: 2px solid @main-color;
  }
  &__form {
    width: 600px;
    .tips {
      color: #f04d52;
      margin-bottom: 5px;
    }
    .trigger {
      text-align: right;
      color: #f04d52;
    }
    .superiorityEg {
      width: 100%;
      margin-top: 15px;
      margin-bottom: 50px;
      padding: 0 15px;
      box-sizing: border-box;
      z-index: 10;

      .superiorityEgInner {
        position: relative;
        padding: 20px;
        background: rgba(190, 203, 240, 0.1);

        .superiorityTit {
          margin-bottom: 10px;
          padding-bottom: 10px;
          border-bottom: 1px solid #eee5e5;
          overflow: hidden;

          .title {
            float: left;
            font-size: 14px;
          }

          .cut {
            float: right;
            color: #666;
            font-size: 14px;
          }
        }

        .superiorityContent {
          line-height: 1.7em;
          -webkit-user-select: none;
          user-select: none;
          font-size: 14px;
          white-space: pre-wrap;
        }
      }

      .super {
        padding-bottom: 60px;
      }

      .superiorityEgInner:before {
        position: absolute;
        left: 0;
        top: -7px;
        border: 7px solid transparent;
        border-left-color: rgba(190, 203, 240, 0.1);
        content: "";
      }
    }
  }
}
</style>
